import { Component, OnInit } from '@angular/core';
import {User} from '../../model/user';
import {ActivatedRoute, Router} from '@angular/router';
import {map} from 'rxjs/operators';
import {LogService} from '../../common/log.service';
import {CommonService} from '../../common/common.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {NotifierService} from '../notifier/notifier.service';
import {UserGuardService} from '../../common/user-guard.service';
import {forkJoin} from 'rxjs/observable/forkJoin';

@Component({
  selector: 'pbc-shared-reports',
  templateUrl: './shared-reports.component.html',
  styleUrls: ['./shared-reports.component.scss']
})
export class SharedReportsComponent implements OnInit {

  private reportId: string;
  constructor(
      private logService: LogService,
      private router : Router,
      private activatedRoute : ActivatedRoute,
      private commonService: CommonService,
      private notifierService: NotifierService,
      private userGuardService: UserGuardService
  ) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(queryParams=>{
      const querySharedReportId = queryParams['reportId'];
      const authData = JSON.parse(localStorage.getItem('auth_data'));
      this.commonService.getSharedReport(querySharedReportId).subscribe(
        (response) => {
          if (response.record.reportSharedTo) {

            if (this.isUserLogged(authData)) {
              this.reportId = response.record.report;
              this.router.navigate(['single-report', this.reportId]);
            } else if (querySharedReportId!=null) {
              this.logInitialStateWrongInitialData(authData, querySharedReportId);
              this.notifierService.notify(NotificationType.SIMPLE_NOTIFICATION, "Użytkownik nie jest zalogowany. Przekierowano do strony logowania");
              this.router.navigate(['login', querySharedReportId]);
            } else {
              this.logInitialStateWrongInitialData(authData, querySharedReportId);
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie podano wymaganych danych");
            }
          } else {
            this.router.navigate(['register']);
          }


        },
        error=>{
          this.logService.warn("error occured: " + error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano raportu");
        });
    });
  }

  private isUserLogged(authData: any) {
    let isLoggedByGuard = this.userGuardService.canActivate();
    return authData && authData.user &&  isLoggedByGuard;
  }

  private logInitialStateWrongInitialData(authData: any, reportId: string) {
    if (authData) {
      if (!authData.user) {
        this.logService.debug('authData.user is null');
      }
    } else {
      this.logService.debug('authData is null');
    }
    if (!reportId) {
      this.logService.warn("reportId should be passed in parameters");
    }
  }
}
